import { Trans } from "@lingui/react/macro";
import { Modal, Title } from "@mantine/core";

import { GetDepartmentData } from "@/shared/api/generated/schemas";

import UpdateDepartmentForm from "./update-department-form";

export default function UpdateDepartmentModal({
  department,
  opened,
  close,
}: {
  department: GetDepartmentData;
  opened: boolean;
  close: () => void;
}) {
  return (
    <Modal
      opened={opened}
      onClose={close}
      size="lg"
      title={
        <Title size="sm">
          <Trans>Endre avdeling</Trans>
        </Title>
      }
    >
      <UpdateDepartmentForm department={department} close={close} />
    </Modal>
  );
}
